import { usePublicProfileData } from '@/context/PublicProfileContext';
import { resolveUserAvatar, resolveAvatarPreset } from '@/data/avatarPresets';

const DEFAULT_BADGE = 'AVAILABLE FOR BOOKINGS · OPEN TO COLLABS · ';

const RIBBON_TARGET_CHARS = 220;
const BADGE_SEP = ' · ';

function buildRibbonRun(text: string): string {
  const core = text.trim().replace(/[\s·•|,-]+$/u, '');
  if (!core) return '';
  const unit = core + BADGE_SEP;
  const repeats = Math.max(1, Math.ceil(RIBBON_TARGET_CHARS / unit.length));
  return unit.repeat(repeats);
}

function CollabRibbon({ text }: { text: string }) {
  const run = buildRibbonRun(text);
  if (!run) return null;

  return (
    <div className="ap-hero__ribbon" aria-hidden="true">
      <div className="ap-hero__ribbon-track">
        <span>{run}</span>
        <span>{run}</span>
      </div>
    </div>
  );
}

export function Hero() {
  const { profile } = usePublicProfileData();
  const handle = profile.handle ? `@${profile.handle}` : '';
  const badgeText = (profile.badgeText || DEFAULT_BADGE).toUpperCase();
  const avatarSrc = resolveUserAvatar(profile);
  const presetFallback = resolveAvatarPreset(profile.avatarPreset);

  return (
    <section className="ap-hero">
      <div className="ap-hero__inner">
        <div className="ap-hero__stage">
          {profile.openToCollabs && <CollabRibbon text={badgeText} />}
          <div className="ap-hero__photo">
            <span className="ap-hero__photo-tape ap-hero__photo-tape--left" />
            <span className="ap-hero__photo-tape ap-hero__photo-tape--right" />
            <img
              className="ap-hero__avatar"
              src={avatarSrc}
              alt={profile.name}
              onError={(e) => {
                e.currentTarget.src = presetFallback;
              }}
            />
          </div>
        </div>
        <div>
          <h1 className="ap-hero__name">{profile.name}</h1>
          {handle && <p className="ap-hero__handle">{handle}</p>}
          {profile.profession && (
            <span className="ap-hero__profession">{profile.profession}</span>
          )}
        </div>
      </div>
      {profile.bio && (
        <p
          className={`ap-hero__bio${profile.profession ? '' : ' ap-hero__bio--no-profession'}`}
        >
          {profile.bio}
        </p>
      )}
    </section>
  );
}
